<script>
import * as vestibularService from '../../services/vestibularService'

import bus from '@utils/bus'
import {get} from '@utils/storage'

export default {
  data () {
    return {
      inscricao: [],
      processo_seletivo: [],
      mostrarModalPdf: false,
      pdfBoleto: null
    }
  },
  async mounted () {
    await this.carregarProcessoSeletivo()
    bus.$emit('hide-loader')
  },
  methods: {
    async carregarProcessoSeletivo () {
      vestibularService.buscarProcessoSeletivo()
        .then((response) => {
          this.processo_seletivo = {...response}
        })
      this.inscricao = await get('inscricao')
    }
  }
}

</script>
<template>
  <div class="vestibular-box">
    <div class="vestibular-content">
      <div class="box-form">
        <h1 class="vestibular-title mb-2 text-xs-center headline font-weight-regular">
          {{ (processo_seletivo.descricao) }}</h1>
        <v-layout row wrap>
          <v-flex class="text-xs-center mb-2">
            <h3 class="mb-4">Inscrição realizada com sucesso!</h3>
            <v-alert
              :value="true"
              class="text-xs-left"
              border="top"
              colored-border
              type="info"
              elevation="2"
            >
              <h3>Muito obrigado pela sua inscrição, leia atentamente as instruções abaixo!!</h3><br>
              - Enviamos um e-mail com os dados da sua inscrição;<br>
              - Caso você tenha escolhido local da prova Online, receberá um link para a realização da prova, que será on-line, basta clicar no link que está
              no e-mail.<br>
              - O link ficará disponível para realização da prova por 7 dias. Se tiver alguma dificuldade com esse
              prazo, entre em contato pelo e-mail proen@urcamp.edu.br ou clique no botão "posso ajudar" que está no
              canto inferior direito da página.
            </v-alert>
          </v-flex>
          <v-flex xs12 class="mb-4" v-if="inscricao.linha_digitavel">
            <v-card flat color="grey lighten-4">
              <v-card-text>
                <h4 class="title mb-2 text-xs-center">Linha digitável:</h4>
                <div class="headline">
                  <div class="linha-ditavel mb-1">{{ inscricao.linha_digitavel }}</div>
                  <div class="text-xs-center">
                    <v-btn v-clipboard:copy="inscricao.linha_digitavel"
                           color="secondary"
                           depressed
                           small>Copiar
                    </v-btn>
                  </div>
                </div>
                <v-divider class="mt-4 mb-4"></v-divider>
                <div class="formas-pagamento d-flex">
                  <div>
                    <v-btn
                      color="primary"
                      large
                      :href="inscricao.boleto_link"
                      target="_blank">
                      <i class="fas fa-print"></i>
                      <span class="pl-1">Imprima seu boleto aqui</span>
                    </v-btn>
                  </div>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      large
                      :href="inscricao.link_pagamento"
                      target="_blank">
                      <i class="fas fa-credit-card"></i>
                      <span class="pl-1">Pague online aqui *</span>
                    </v-btn>
                  </div>
                </div>
                <v-divider class="mt-4 mb-4"></v-divider>
                * Ao clicar em pagar online você será redirecionado para o ambiente de pagamento da PagBrasil
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 class="mb-4">
            <p class="text-xs-center ma-2">
              <a href="https://urcamp.edu.br/">Ir para site da URCAMP</a>
            </p>
          </v-flex>
        </v-layout>
      </div>
      <div class="box-banner"></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.vestibular-box {
  width: 100%;
  height: 100vh;
  color: #747474;
  margin-bottom: 100px;

  .vestibular-content {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;

    .box-form {
      width: 50vw;
      min-height: 100vh;
      padding-left: 50px;
      padding-right: 50px;
      padding-top: 50px;
      background: #FFF;
    }

    .box-banner {
      min-height: 100vh;
      width: 50vw;
      background-image: url('/static/img/vestibular/banner_inscricao_desktop.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }

    .box-linha-digitavel {
      border: 1px solid #9CADB6;
      border-radius: 10px 10px;
    }

    .vestibular-title {
      color: #11b1d4;
      text-transform: uppercase;
    }
  }
}

@media all and (min-width: 641px) and (max-width: 1080px) {
  .vestibular-box {
    .vestibular-content {
      .box-banner {
        background-image: url('/static/img/vestibular/topo_inscricao_mobile.png');
        background-position: center center;
        background-size: contain;
        order: 0;
        min-height: 100vh;
        height: auto;
        padding-top: 26.25%
      }

      .box-form {
        order: 1;
      }

      .box-banner,
      .box-form {
        width: 100%;
        min-height: 100%;
      }
    }
  }
}

@media all and (max-width: 640px) {
  .vestibular-box {
    .vestibular-content {
      .box-banner {
        background-image: url('/static/img/vestibular/topo_inscricao_mobile.png');
        background-position: center center;
        order: 0;
        min-height: 100vh;
        height: 100px;
      }

      .box-form {
        order: 1;
      }

      .box-banner,
      .box-form {
        width: 100%;
        min-height: 100%;
      }
    }
  }
}

.linha-ditavel {
  text-align: center;
}

@media all and (max-width: 800px) {
  .linha-ditavel {
    font-size: 16px;
    text-align: center;
  }

  .formas-pagamento {
    flex-direction: column;

    > div {
      width: 100%;

      > .v-btn {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Finalizacao.vue?bb854330